@if ( names && names.length > 0 ) {
<dl class="row">
  <dt class="col-sm-1">{{ label }}:</dt>
  <dd class="col-sm-11">
    {{ names }}
  </dd>
</dl>
}
